import I18n from 'hooks/useI18n';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './styles.scss';
import { TIMEOUT_TRY_RECONNECT_NOW } from 'redhotpie-shared-lib/constants/constants';
import { loadingGrey } from 'redhotpie-shared-lib/themes/ImagesSVG';

let timeoutClick: NodeJS.Timeout | null = null;
const refTimeout: NodeJS.Timeout | null = null;

interface ReconnectingLabelProps {
  className?: string;
  isShowRetryButton: boolean;
  isRetryLoading: boolean;
  tryReconnect: () => void;
  publicGroupChat: boolean;
}
const ReconnectingLabel = ({
  className = '',
  isShowRetryButton,
  isRetryLoading,
  tryReconnect,
  publicGroupChat,
}: ReconnectingLabelProps) => {
  function onClickTryReconnect() {
    if (timeoutClick) {
      return;
    }
    tryReconnect();
    timeoutClick = setTimeout(() => {
      if (timeoutClick) {
        clearTimeout(timeoutClick);
      }
      timeoutClick = null;
    }, TIMEOUT_TRY_RECONNECT_NOW);
  }

  return (
    <div className={cn('reconnect-warning', className)}>
      <img alt="ic-loading" className="reconnect-warning__loading" src={loadingGrey} />
      <span>{I18n.t('Reconnect.Info')}</span>
      {isShowRetryButton && !isRetryLoading && (
        <span className="span-text-decoration" onClick={onClickTryReconnect}>
          {I18n.t('Reconnect.Action')}
        </span>
      )}
    </div>
  );
};

ReconnectingLabel.displayName = 'ReconnectingLabel';
ReconnectingLabel.propTypes = {
  className: PropTypes.string,
  isShowRetryButton: PropTypes.bool,
  isRetryLoading: PropTypes.bool,
  tryReconnect: PropTypes.func,
};
ReconnectingLabel.defaultProps = {};

export default ReconnectingLabel;
